import { render } from "./home.item.vue?vue&type=template&id=428c2ba9"
import script from "./home.item.vue?vue&type=script&lang=js"
export * from "./home.item.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__